import { createFileRoute, redirect } from "@tanstack/react-router";

import { LoginPage } from "@onesolution/pages";
import { getUserFromSession } from "@onesolution/utils";

export const Route = createFileRoute("/(auth)/login")({
	beforeLoad: async () => {
		const user = await getUserFromSession();

		// biome-ignore lint/complexity/useOptionalChain: false positive
		if (user && user?.isAuthenticated) {
			throw redirect({ to: "/", replace: true });
		}
	},
	loader: async ({ context: { queryClient, ...user } }) => {
		const userS = await getUserFromSession();

		return { user, userS };
	},
	component: LoginPage,
});
